import { Interlocuteur } from '@/models/Interlocuteur';
import { Site } from '@/models/Site';
import { Component, markRaw } from 'vue';
import SelectSiteContact from '../components/SelectSiteContact.vue';
import SelectInterlocuteur from '../components/SelectInterlocuteur.vue';
import MessageForm from '../components/MessageForm.vue';

export interface ContactState {
    step: number;
    site?: Site;
    interlocuteur?: Interlocuteur;
    objet: string;
    description: string;
    isLoadingInterlocuteurs: boolean;
    interlocuteurs: Interlocuteur[];
    isSendingMessage: boolean;
    isSuccess: boolean;
    steps: Component[];
    exportLoading: boolean;
}

export const initialState: ContactState = {
    step: 0,
    site: undefined,
    interlocuteur: undefined,
    isLoadingInterlocuteurs: false,
    interlocuteurs: [],
    objet: '',
    description: '',
    isSendingMessage: false,
    isSuccess: false,
    steps: [ markRaw(SelectSiteContact), markRaw(SelectInterlocuteur), markRaw(MessageForm) ],
    exportLoading: false,
};

export const state: ContactState = {
    ...initialState
};
